module.exports = __webpack_public_path__ + "static/puck-side-13e0d9f0197a9125ad867bb753e7e8b9.jpg";